export default "__VITE_ASSET__CGL898tx__"